import get from "lodash/get";
import { STATE_KEYS } from "utils/constants/state";

export const getShowConfigTaxFields = ({ values, inherited }) => {
  const standardAutoTaxes = get(
    values,
    STATE_KEYS.SHORT_LINK.AUTOMATIC_TAX_ENABLED
  );
  const standardTaxes = get(values, STATE_KEYS.SHORT_LINK.TAX_RATES);
  const hasStandardTaxRates =
    Array.isArray(standardTaxes) && standardTaxes.length;
  const standardTaxId = get(
    values,
    STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_ENABLED
  );

  const definedStandardAutoTaxes = typeof standardAutoTaxes !== "undefined";
  const definedStandardTaxRates = typeof standardTaxes !== "undefined";
  const definedStandardTaxIdValue = typeof standardTaxId !== "undefined";

  /**
   * Inherited
   */
  const inheritedAutoTaxes = get(
    inherited,
    STATE_KEYS.SHORT_LINK.AUTOMATIC_TAX_ENABLED
  );
  const inheritedTaxRates = get(inherited, STATE_KEYS.SHORT_LINK.TAX_RATES);
  const inheritedTaxId = get(
    inherited,
    STATE_KEYS.SHORT_LINK.TAX_ID_COLLECTION_ENABLED
  );

  const definedInheritedAutoTaxes = typeof inheritedAutoTaxes !== "undefined";
  const definedInheritedTaxRates = typeof inheritedTaxRates !== "undefined";
  const definedInheritedTaxId = typeof inheritedTaxId !== "undefined";

  /**
   * Show logic
   */
  const showInheritedAutoTaxes =
    definedInheritedAutoTaxes && !definedStandardAutoTaxes;
  const showStandardAutoTaxes =
    definedStandardAutoTaxes && !hasStandardTaxRates;

  /**
   * If defined
   * inherited auto tax false
   * andand all standard ard undefined
   */
  const showInheritedTaxRates =
    definedInheritedTaxRates &&
    !inheritedAutoTaxes &&
    !definedStandardAutoTaxes &&
    !definedStandardTaxRates;

  const showStandardTaxRates = definedStandardTaxRates && !standardAutoTaxes;
  const showInheritedTaxId =
    definedInheritedTaxId && !definedStandardTaxIdValue;
  const showStandardTaxId = definedStandardTaxIdValue;

  return {
    showStandardAutoTaxes,
    showInheritedAutoTaxes,
    showStandardTaxRates,
    showInheritedTaxRates,
    showInheritedTaxId,
    showStandardTaxId
  };
};
